import React, { useContext } from 'react';
import styled, { css } from 'styled-components'
import { ColorGreyDark, bezier, colorTeal, colorPurple } from '../styles/sharedStyles';
import { ReactComponent as Icon } from '../assets/icons/settingsIcon.svg'
import Switch from "react-switch";  
import { ChartContext } from "../context/ChartContext"
import data from '../data/questions.json'
import getTreeData from '../data/treeData';

const size = 15

const Container = styled.div`

    ${props => props.setOpacity ? css`
        opacity: 1;
        visibility: visible;
    ` : css`
        opacity: 0;
        visibility: hidden;
    `}

    background-color: ${ColorGreyDark};

    position: fixed;
    top: -${size/2}rem;
    right: -${size/2}rem;

    height: ${size}rem;
    width: ${size}rem;
    border-radius: 100%;

    z-index: 10000;
    transition: all .5s ${bezier};

    &:hover{
        top: -${(size*2 ) /2}rem;
        right: -${(size*2 ) /2}rem;

        height: ${size * 2}rem;
        width: ${size * 2}rem;
    }

    &:hover > .icon-container {
        transition-delay: 0s;
        transition-duration: 0s;
        visibility: hidden;
        opacity: 0;
    }

    &:hover > .controls-container {
        transition-delay: .2s;
        transition-duration: .3s;
        visibility: visible;
        opacity: 1;
    }

    .icon-container {

        pointer-events: none;
        user-select: none;

        background: transparent;
        position: fixed;
        top: 0rem;
        right: 0rem;
        
        padding: 1.2rem 1.4rem;
        color: #fff;


        .icon {
            height: ${size/5}rem;
            width: ${size/5}rem;
            fill: #fff;
            ${'' /* transform: rotate(180deg); */}
            cursor: pointer;
        }
        
    }

    .controls-container {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: flex-end;
        position: fixed;
        top: 1.5rem;
        right: 2rem;
        color: #fff;

        visibility: hidden;
        opacity: 0;

        .switch {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: flex-end;
        }

        .reset {
            margin-top: 1.5rem;
            text-align: right;
            color: #fff;
            cursor: pointer;

            border: 1px solid #fff;
            border-radius: 3px;
            padding: .25rem .5rem;
        }

    }

`

const FixedControl = (
    { opacity }
) => {

    const { path, setPath, setFutureMapFilterValues,
        setDisplayedMetrics,  setFiltersQuestions, setChartQuestions, setMapFilterValues, setFilteredAnswers  } = useContext(ChartContext)
    
    const { regionList } = getTreeData(path)

    const resetAll = () => {
        setDisplayedMetrics([...data.questions])
        setMapFilterValues(regionList)
        setFutureMapFilterValues(regionList)
        setFiltersQuestions([])
        setChartQuestions([])
        setFilteredAnswers([])
    }
    return ( 
        <Container
            setOpacity={opacity}
            data-tut="fixed-control"
        >
            <div className="icon-container">
                <Icon
                    className="icon"
                />
            </div>
            <div className="controls-container">
                <div className="switch">
                    <Switch 
                        checkedIcon={false}
                        uncheckedIcon={false}
                        offColor={colorTeal}
                        onColor={colorPurple}
                        onChange={() => setPath( path === "hrds" ? "les" : "hrds" )}
                        checked={path === "hrds" ? false : true}
                    />
                    <div>
                        Change to {path === "hrds" ? "LEs" : "HRDs"}
                    </div>
                </div>
                    <div 
                        className="reset"
                        onClick={resetAll}
                    >
                        Reset all
                    </div>
            </div>
        </Container>
     );
}
 
export default FixedControl;